import * as segmentio from 'rp-analytics';

const sectionDefault = 'Homepage';
const sections = {
    homepage: sectionDefault,
    'cheltenham-festival': 'Cheltenham festival',
    'the-derby': 'The derby',
    'grand-national': 'Grand national',
    'champions-day': 'Champions day',
    'royal-ascot': 'Royal ascot',
    'glorious-goodwood': 'Glorious goodwood',
    'breeders-cup': 'Breeders cup',
    '1000-guineas': '1,000 Guineas',
    '2000-guineas': '2,000 Guineas',
    'melbourne-cup': 'Melbourne cup',
    pools: 'Tote Pools',
    'ten-to-follow': 'Ten To Follow Competition',
};

export const getPageSection = () => {
    const pathnameSplit = window.location.pathname.split('/');
    const page = pathnameSplit[1];
    const pageSection = !page || !sections[page] ? sectionDefault : sections[page];

    return pageSection;
};

export default function analyticsPage() {
    const newSection = getPageSection();

    segmentio.setCommonTraits({
        [segmentio.TRAIT_SITE_SECTION]: newSection,
        [segmentio.TRAIT_SITE_SUB_SECTION_1]: null,
        [segmentio.TRAIT_SITE_SUB_SECTION_2]: null,
    });

    segmentio.page();
}



// WEBPACK FOOTER //
// ./src/js/analyticsPage.js